import {
  GET_COURSE_COMPONENTS,
  GET_COURSE_COMPONENTS_FAIL,
  GET_COURSE_COMPONENTS_SUCCESS,
  ADD_NEW_COURSE_COMPONENT,
  ADD_COURSE_COMPONENT_SUCCESS,
  ADD_COURSE_COMPONENT_FAIL,
  UPDATE_COURSE_COMPONENT,
  UPDATE_COURSE_COMPONENT_SUCCESS,
  UPDATE_COURSE_COMPONENT_FAIL,
  DELETE_COURSE_COMPONENT,
  DELETE_COURSE_COMPONENT_SUCCESS,
  DELETE_COURSE_COMPONENT_FAIL,
  
} from "./actionTypes";

export const getCourseComponents = () => ({
  type: GET_COURSE_COMPONENTS,
})

export const getCourseComponentsSuccess = courseComponents => ({
  type: GET_COURSE_COMPONENTS_SUCCESS,
  payload: courseComponents,
})

export const getCourseComponentsFail = error => ({
  type: GET_COURSE_COMPONENTS_FAIL,
  payload: error,
})

export const addNewCourseComponent = data => ({
  type: ADD_NEW_COURSE_COMPONENT,
  payload: data,
})

export const addCourseComponentSuccess = courseComponent => ({
  type: ADD_COURSE_COMPONENT_SUCCESS,
  payload: courseComponent,
})

export const addCourseComponentFail = error => ({
  type: ADD_COURSE_COMPONENT_FAIL,
  payload: error,
})

export const updateCourseComponent = courseComponent => ({
  type: UPDATE_COURSE_COMPONENT,
  payload: courseComponent,
})

export const updateCourseComponentSuccess = courseComponent => ({
  type: UPDATE_COURSE_COMPONENT_SUCCESS,
  payload: courseComponent,
})

export const updateCourseComponentFail = error => ({
  type: UPDATE_COURSE_COMPONENT_FAIL,
  payload: error,
})

export const deleteCourseComponent = data => ({
  type: DELETE_COURSE_COMPONENT,
  payload: data,
})

export const deleteCourseComponentSuccess = data => ({
  type: DELETE_COURSE_COMPONENT_SUCCESS,
  payload: data,
})

export const deleteCourseComponentFail = error => ({
  type: DELETE_COURSE_COMPONENT_FAIL,
  payload: error,
})

export const resetCourseComponentLastActionSuccess = () => ({
    type: "RESET_LAST_ACTION_SUCCESS"
});

